import { STT_LIKE_VENUES } from '@/shared/enums/venueData';

export class VenueDataAccessor {
  private venueData: SNDomainData | null = null;

  getVenueData() {
    if (!this.venueData) throw new Error(`No venue data loaded.`);

    return this.venueData;
  }

  setVenueData(config: SNDomainData) {
    this.venueData = config;
  }

  /**
   * True for STT-like venues — STT itself plus every venue that reuses the STT flow
   * (IMAX today, and any future STT-style venue). Named "STT-like", not "isStt", because it
   * is not literally only STT. Membership is explicit (see {@link STT_LIKE_VENUES}).
   */
  get isSttLikeFlow(): boolean {
    return STT_LIKE_VENUES.includes(this.getVenueData()?.venueName);
  }

  isSttLikeVenue(venueName: SNDomainData['venueName']) {
    return STT_LIKE_VENUES.includes(venueName);
  }

  get isSttVenue(): boolean {
    return this.venueData?.venueName === 'stt';
  }

  venueOrderAndProductSummaryBlockThemeMode(): 'light' | 'dark' | undefined {
    if (!this.venueData?.venueName) return;

    switch (this.venueData?.venueName) {
      case 'stt':
      case 'imax':
        return 'light';
      default:
        return 'dark';
    }
  }
}

export const venueDataAccessor = new VenueDataAccessor();
